module.exports = __webpack_public_path__ + "img/1f9c3.562a3f5.svg";